export default [
  {
    path: '/project',
    component: () => import('@/views/pages/project/index.vue'),
    redirect: '/project/create',
    children: [
      {
        path: 'create',
        name: 'create',
        meta: { title: "我的作品" },
        component: () => import('@/views/pages/project/index.vue')
      },
      {
        path: ':codeID',
        name: 'userBlog',
        meta: { title: "我的作品" },
        component: () => import('@/views/pages/project/index.vue')
      },
    ]
  },
  {
    path: '/project/:userID',
    component: () => import('@/views/pages/project/user.vue'),
    redirect: '/project/:userID/',
    children: [
      {
        path: 'index',
        name: 'index',
        meta: { title: "学生作品" },
        component: () => import('@/views/pages/project/user.vue')
      },
      {
        path: ':codeID',
        name: 'user',
        meta: { title: "学生作品" },
        component: () => import('@/views/pages/project/user.vue')
      },
    ]
  }
]
